import { ChartManager } from "..";

/**
 * Classe gerenciadora dos gráficos evolutivos.
 */
export class EvolutiveChartManager extends ChartManager {
  constructor(instance) {
    super(instance);
  }
}